import { Text } from "@mantine/core";
import guide from "../../assets/merchantbenefits.svg";
import works from "../../assets/howitworks1.svg";
import { Button } from "@funded-here-interface/common";
import { useStyles } from "./D2Zguidecss";
import { useNavigate } from "react-router-dom";
import { FC } from "react";

const D2ZguideMerchantPage1: FC = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  return (
    <div>
      <div className={classes.centerText}>
        <Text className={classes.headerText}>d2z Funding</Text>
        <Text>Welcome to FundedHere!</Text>
        <Text>
          {" "}
          We’d like to introduce to a first of its kind financing solution
        </Text>
        <hr className={classes.separator} />
      </div>
      <div className={classes.centerText} style={{ marginTop: "50px" }}>
        <Text className={classes.benefitsAndWorksText}>Benefits</Text>
        <div>
          <img src={guide} alt="" />
        </div>
        <div className={classes.howitworks}>
          <Text className={classes.benefitsAndWorksText}>How it works</Text>
          <div className={classes.workstext}>
            <Text style={{ fontWeight: 800 }}>Loan application process</Text>
            <Text style={{ color: "#979797" }}>Repayment Process</Text>
          </div>

          <img src={works} style={{ width: "auto", marginTop: 30 }} alt="" />
          <div className={classes.buttonContainer}>
            <Button
              textColor="white"
              children="Next!"
              onClick={() => {
                navigate("/onboarding-guide-merchant-repayment");
              }}
              backgroundColor="#F6BD21"
            ></Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default D2ZguideMerchantPage1;
